export const environment = {
    production: true,
    basePathApi: 'https://wondrlink-back.vercel.app/api',
    authPathApi: 'https://wondrlink-back.vercel.app/api/auth',
    geoPathAPI: 'https://api.geoapify.com/v1/geocode/autocomplete',
    geoApiKey: '3b23dc57405b446fbbf29846a2d2b6dd',
    locationIqToken: 'pk.0e75ab005ceb08e738472e1ae6f534ca',
    geniusscansdkToken: '533c50075255010008550756394642144a145d0a504444560b555115195b5f5d3d0553540b040505530001'
};
